/** Placeholders for a detail the reply already matched. */
const SLOT_PLACEHOLDER: Record<string, string> = {
  notice: "{notice}",
  topic: "{notice}",
  user: "{user}",
  audience: "{circle}",
  circle: "{circle}",
  date: "{date}",
  day: "{date}",
  dateRange: "{date}",
  child: "{child}",
  contact: "{email}",
};

const EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
/** Phone and ID numbers. A 4-digit year is left as it is. */
const LONG_NUMBER = /\d{5,}/g;

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Replaces one whole name or detail. A name inside a longer word ("Ann" in "Annual") stays.
 */
function replaceWhole(text: string, value: string, placeholder: string): string {
  const trimmed = value.trim();
  if (trimmed.length < 2) return text;
  return text.replace(new RegExp(`\\b${escapeRegExp(trimmed)}\\b`, "gi"), placeholder);
}

/**
 * The question as it may be stored: matched details, known names, phone and ID
 * numbers, and email addresses taken out. A 4-digit year stays.
 */
export function redactQuestion(
  question: string,
  knownNames: string[],
  matched: Record<string, string> = {}
): string {
  let text = question.replace(EMAIL, "{email}").replace(LONG_NUMBER, "{number}");

  const details = Object.entries(matched)
    .filter((entry): entry is [string, string] => typeof entry[1] === "string" && entry[1].trim().length >= 2)
    .sort((a, b) => b[1].length - a[1].length);
  for (const [slot, value] of details) {
    text = replaceWhole(text, value, SLOT_PLACEHOLDER[slot] ?? `{${slot}}`);
  }

  const names = [...knownNames].filter((name) => name.trim().length >= 2).sort((a, b) => b.length - a.length);
  for (const name of names) {
    text = replaceWhole(text, name, "{name}");
  }
  return text;
}
